class CavernPagePopup extends HTMLElement {
  connectedCallback() {
    this.popupId = this.dataset.popupId || 'site-popup';
    this.storageKey = `cavern-page-popup-${this.popupId}`;
    this.dialog = this.querySelector('[role="dialog"]');
    this.closeButtons = this.querySelectorAll('[data-popup-close]');
    this.designMode = window.Shopify && Shopify.designMode;

    if (!this.designMode && this.wasClosedThisSession()) {
      return;
    }

    this.closeButtons.forEach((button) => button.addEventListener('click', () => this.close()));
    this.addEventListener('click', (event) => {
      if (event.target === this) this.close();
    });

    this.escapeHandler = (event) => {
      if (event.key === 'Escape' && this.classList.contains('is-visible')) this.close();
    };
    document.addEventListener('keydown', this.escapeHandler);

    window.setTimeout(() => this.open(), Number(this.dataset.delay || 0));
  }

  disconnectedCallback() {
    if (this.escapeHandler) {
      document.removeEventListener('keydown', this.escapeHandler);
    }
  }

  open() {
    this.classList.add('is-visible');
    this.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cavern-page-popup-open');

    const focusTarget = this.querySelector('[data-popup-close]') || this.dialog;
    if (focusTarget) focusTarget.focus();
  }

  close() {
    this.classList.remove('is-visible');
    this.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cavern-page-popup-open');

    if (!this.designMode) this.markClosedThisSession();
  }

  wasClosedThisSession() {
    try {
      return window.sessionStorage.getItem(this.storageKey) === 'closed';
    } catch (error) {
      return false;
    }
  }

  markClosedThisSession() {
    try {
      window.sessionStorage.setItem(this.storageKey, 'closed');
    } catch (error) {
      // Ignore storage failures from private browsing or blocked storage.
    }
  }
}

if (!customElements.get('cavern-page-popup')) {
  customElements.define('cavern-page-popup', CavernPagePopup);
}
